import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AutocompleteSelectFilter from '../AutocompleteSelectFilter/AutocompleteSelectFilter.jsx';
import { SALARY_SOURCE } from '../../../Services/salaries.service';
import styles from './CodeSourcePicker.module.scss';

/** A label, an account cards / sort codes toggle and the codes multi-select. */
const CodeSourcePicker = ({ label, value, onChange, optionsBySource, disabled, compact }) => {
    const { t, i18n } = useTranslation();
    const sourceType = value?.sourceType || SALARY_SOURCE.ACCOUNT_CARDS;
    const codes = value?.codes || [];
    const options = optionsBySource?.[sourceType] || [];
    const optionByValue = new Map(options.map((option) => [option.value, option]));
    const selected = codes.map((code) => optionByValue.get(code) || { value: code, label: code });

    return (
        <div className={`${styles.row} ${label ? '' : styles.noLabel} ${compact ? styles.compact : ''}`}>
            {label ? <span className={styles.label}>{label}</span> : null}
            <ToggleButtonGroup
                className={styles.toggle}
                size="small"
                exclusive
                value={sourceType}
                onChange={(e, next) => next && next !== sourceType && onChange({ sourceType: next, codes: [] })}
                disabled={disabled}
            >
                <ToggleButton value={SALARY_SOURCE.ACCOUNT_CARDS}>{t('SalarySourceAccountCards')}</ToggleButton>
                <ToggleButton value={SALARY_SOURCE.SORT_CODES}>{t('SalarySourceSortCodes')}</ToggleButton>
            </ToggleButtonGroup>
            <div className={styles.select}>
                <AutocompleteSelectFilter
                    options={options}
                    selectedValues={selected}
                    onChange={(e, values) => onChange({ sourceType, codes: (values || []).map((v) => String(v.value)) })}
                    placeholder={sourceType === SALARY_SOURCE.SORT_CODES ? t('SalaryChooseSortCodes') : t('SalaryChooseAccountCards')}
                    isMultiple
                    isDisabled={disabled}
                    direction={i18n.dir()}
                    searchable
                    portalMenu
                    showAllSelected
                />
            </div>
        </div>
    );
};

CodeSourcePicker.propTypes = {
    label: PropTypes.node,
    value: PropTypes.shape({ sourceType: PropTypes.number, codes: PropTypes.arrayOf(PropTypes.string) }),
    onChange: PropTypes.func.isRequired,
    optionsBySource: PropTypes.object,
    disabled: PropTypes.bool,
    compact: PropTypes.bool,
};

export default CodeSourcePicker;
